"use client";

import { createAuthClient } from "better-auth/react";
import { magicLinkClient } from "better-auth/client/plugins";

// Nincs explicit baseURL: a Better Auth React kliens ilyenkor relatív
// "/api/auth"-ra hívja a szervert (böngészőben window.location.origin ellen
// oldódik fel), így a klub-portál domainen (pl. bpse-teszt.boulium.com)
// is same-origin marad a hívás — nem a primary hostra posztol. Ellenőrizve:
// node_modules/better-auth/dist/client/config.mjs getClientConfig() —
// baseURL hiányában "/api/auth"-ra esik vissza (nincs SSR-használat itt,
// ez a fájl kizárólag "use client" komponensből fut). (W7)
export const authClient = createAuthClient({
  plugins: [magicLinkClient()],
});

export const { signIn, signOut, useSession } = authClient;
